import i18n from '@/i18n'
import Index from './index.vue'
import Layout from '../layout.vue'
import { COMPANY_ADMIN_MENU_GROUP_KEY } from '@/constant/company'

const pathPrefix = '/v-admin/company-admin/custom-job-detail-page'

const customJobDetailPageRoute = {
  path: `${pathPrefix}`,
  component: Layout,
  meta: {
    permission: ['PERM_CUSTOMIZE_JOB_DETAIL_PAGE', 'PREMIUM_CUSTOM_JOB_DETAIL', 'PREMIUM_CUSTOM_JOB_DETAIL_COMPANY_LEVEL'],
    titleI18nKey: 'admin.company.customJobDetailPage.menu',
    menu: {
      labelI18nKey: i18n.t('admin.company.customJobDetailPage.menu'),
      get label () {
        return i18n.t('admin.company.customJobDetailPage.menu')
      },
      group: COMPANY_ADMIN_MENU_GROUP_KEY.CUSTOMER_BRAND
    },
    breadcrumb: { hidden: true },
    isNewPage: true,
    isAllInclude: true,
    isRootBreadcrumb: true
  },
  children: [
    {
      path: '',
      component: Index,
      meta: {
        titleI18nKey: 'admin.company.customJobDetailPage.menu'
      }
    }
  ]
}

export default customJobDetailPageRoute
